
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60.466 13.044c-7.764 0-17.339 5.33-22.437 10.68-5.04 5.291-8.257 13.017-8.196 21.069.002 10.793 5.64 19.656 14.406 24.926.805.573 1.076 1.224 1.076 2.19l1.157 13.578L74.787 83.5l1.244-10.743c0-.517-.249-1.406 0-1.854.204-.37.496-.97.881-1.184 8.06-4.484 12.982-14.306 13.11-24.926 0-8.057-2.718-16.854-7.782-22.145-5.111-5.341-14.018-9.604-21.774-9.604",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M83.887 20.242c-6.048-6.276-14.354-10.18-23.446-10.18-9.096 0-17.407 3.909-23.441 10.19-6.047 6.296-9.813 14.977-9.813 24.54 0 12.039 4.682 21.676 14.168 27.962v13.05c0 .761.543 1.475 1.167 2.044.47.485 1.235.669 2.133.68l32.352-2.668a3.07 3.07 0 0 0 1.896-.945c.448-.473.743-1.095.743-1.788V72.911c8.226-5.73 14.164-16.13 14.167-28.11-.057-9.574-3.857-18.261-9.926-24.56zm-43.291 3.926c5.046-5.368 12.039-8.68 19.726-8.68 7.678 0 14.664 3.305 19.724 8.663 5.013 5.308 8.131 12.633 8.131 20.716-.127 10.656-4.805 19.6-12.783 24.1-.381.214-.67.538-.872.909-.246.45-.37.969-.37 1.487v9.428l-27.66 2.312v-11.74c0-.97-.35-1.904-1.147-2.479-8.677-5.288-12.76-13.18-12.762-24.01-.06-8.077 3.022-15.397 8.013-20.706",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M76.329 92.113a2.44 2.44 0 0 1 1.862.598 2.63 2.63 0 0 1 .867 1.862c.07.826-.17 1.52-.609 2.047a2.67 2.67 0 0 1-1.78.955l-32.121 2.426c-.775-.015-1.45-.262-1.95-.704-.517-.46-.83-1.114-.897-1.84a2.67 2.67 0 0 1 .614-1.954 2.67 2.67 0 0 1 1.78-.956zm-10.203 11.463a2.6 2.6 0 0 1 1.834.664c.484.44.794 1.069.825 1.792.071.826-.168 1.52-.608 2.047a2.68 2.68 0 0 1-1.79.957L54.928 110c-.771-.016-1.444-.264-1.94-.704-.519-.46-.831-1.114-.898-1.84-.066-.74.177-1.43.614-1.954a2.68 2.68 0 0 1 1.79-.957zm-.819-76.21a2.6 2.6 0 0 1 2.122-.09c2.435.883 6.005 3.175 8.34 6.987 1.636 2.67 2.655 6.089 2.247 10.293a3.28 3.28 0 0 1-.999 2.029 2.82 2.82 0 0 1-1.88.788c-.912-.099-1.67-.495-2.18-1.083a2.92 2.92 0 0 1-.693-2.23c.282-2.76-.378-4.9-1.367-6.53-1.788-2.951-4.699-4.221-5.304-4.44a3.07 3.07 0 0 1-1.626-1.593 3.35 3.35 0 0 1-.137-2.406c.253-.782.8-1.392 1.477-1.725",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" ><path d=\"M60.466 13.044c-7.764 0-17.339 5.33-22.437 10.68-5.04 5.291-8.257 13.017-8.196 21.069.002 10.793 5.64 19.656 14.406 24.926.805.573 1.076 1.224 1.076 2.19l1.157 13.578L74.787 83.5l1.244-10.743c0-.517-.249-1.406 0-1.854.204-.37.496-.97.881-1.184 8.06-4.484 12.982-14.306 13.11-24.926 0-8.057-2.718-16.854-7.782-22.145-5.111-5.341-14.018-9.604-21.774-9.604\" fill=\"var(--theme-bright, #e3d2e9)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.887 20.242c-6.048-6.276-14.354-10.18-23.446-10.18-9.096 0-17.407 3.909-23.441 10.19-6.047 6.296-9.813 14.977-9.813 24.54 0 12.039 4.682 21.676 14.168 27.962v13.05c0 .761.543 1.475 1.167 2.044.47.485 1.235.669 2.133.68l32.352-2.668a3.07 3.07 0 0 0 1.896-.945c.448-.473.743-1.095.743-1.788V72.911c8.226-5.73 14.164-16.13 14.167-28.11-.057-9.574-3.857-18.261-9.926-24.56zm-43.291 3.926c5.046-5.368 12.039-8.68 19.726-8.68 7.678 0 14.664 3.305 19.724 8.663 5.013 5.308 8.131 12.633 8.131 20.716-.127 10.656-4.805 19.6-12.783 24.1-.381.214-.67.538-.872.909-.246.45-.37.969-.37 1.487v9.428l-27.66 2.312v-11.74c0-.97-.35-1.904-1.147-2.479-8.677-5.288-12.76-13.18-12.762-24.01-.06-8.077 3.022-15.397 8.013-20.706\" fill=\"var(--theme-primary, #810ea9)\"/><path d=\"M76.329 92.113a2.44 2.44 0 0 1 1.862.598 2.63 2.63 0 0 1 .867 1.862c.07.826-.17 1.52-.609 2.047a2.67 2.67 0 0 1-1.78.955l-32.121 2.426c-.775-.015-1.45-.262-1.95-.704-.517-.46-.83-1.114-.897-1.84a2.67 2.67 0 0 1 .614-1.954 2.67 2.67 0 0 1 1.78-.956zm-10.203 11.463a2.6 2.6 0 0 1 1.834.664c.484.44.794 1.069.825 1.792.071.826-.168 1.52-.608 2.047a2.68 2.68 0 0 1-1.79.957L54.928 110c-.771-.016-1.444-.264-1.94-.704-.519-.46-.831-1.114-.898-1.84-.066-.74.177-1.43.614-1.954a2.68 2.68 0 0 1 1.79-.957zm-.819-76.21a2.6 2.6 0 0 1 2.122-.09c2.435.883 6.005 3.175 8.34 6.987 1.636 2.67 2.655 6.089 2.247 10.293a3.28 3.28 0 0 1-.999 2.029 2.82 2.82 0 0 1-1.88.788c-.912-.099-1.67-.495-2.18-1.083a2.92 2.92 0 0 1-.693-2.23c.282-2.76-.378-4.9-1.367-6.53-1.788-2.951-4.699-4.221-5.304-4.44a3.07 3.07 0 0 1-1.626-1.593 3.35 3.35 0 0 1-.137-2.406c.253-.782.8-1.392 1.477-1.725\" fill=\"var(--theme-primary, #810ea9)\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light.c46b21350eb2803692c2bacb8f1ea85e.svg"),
        {
          React: SvgLight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      